export default __webpack_public_path__ + "static/media/file-text-big.cd2067ca.svg";